var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M55.392 11.259H0v-1.5h55.392L52.54 0c3.9 4.2 10.058 8.106 15.011 10.508-4.954 2.4-11.108 6.3-15.011 10.508z","fill":"#1f2f22","key":0}),React.createElement("path",{"d":"M55.392 11.259H0v-1.5h55.392L52.54 0c3.9 4.2 10.058 8.106 15.011 10.508-4.954 2.4-11.108 6.3-15.011 10.508z","fill":"#1f2f22","key":1})]);
}

ArrowIcon.defaultProps = {"width":"67.551","height":"21.016"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
